import { Injectable, Inject } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';

import { UserActions } from '@nw/ui-core-shared/store/actions';
import { AuthenticationService } from '@nw/ui-core-shared/services/authentication.service';
import { Observable } from 'rxjs/Observable';
import { SessionService } from '@nw/ui-core-shared/services/session.service';
import { AppPrincipal } from '@nw/ui-core-shared/services/app-principal';
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';
import { AppUiActions } from '@nw/ui-core-shared/store/actions';
import { LanguageService } from '@nw/ui-core-shared/services/language.service';
import { BrowserWindow } from '@nw/ui-core-shared/services/browser-window.service';
import { environment } from '../../../environments/environment';
import { UtilityService } from '@nw/ui-core-shared/services/utility.service';

@Injectable()
export class UserEffects {
  constructor(private actions$: Actions,
              private userActions: UserActions,
              private authService: AuthenticationService,
              private sessionService: SessionService,
              private storeService: MainStoreService,
              private uiActions: AppUiActions,
              private languageService: LanguageService,
              private browserWindow: BrowserWindow,
              private utilityService: UtilityService,
              @Inject('windowObject') private window: any) {
  }

  @Effect() devLogin = this.actions$
    .ofType(UserActions.DEV_LOGIN)
    .switchMap((action) => {
      const loginInfo = action.payload;
      return this.authService
        .devLogin(loginInfo.userData, loginInfo.language, loginInfo.plId, loginInfo.userName, loginInfo.password, null, loginInfo.testMode)
        .map((jsonUser) => this.userActions.loginSuccess(jsonUser))
        .retryWhen(this.utilityService.handleRetry)
        .catch(err => Observable.of(this.userActions.loginFail()));
    });

  @Effect() login = this.actions$
    .ofType(UserActions.LOGIN)
    .switchMap((action) => {
      const loginInfo = action.payload;

      return this.authService
        .login(loginInfo.userData, loginInfo.language, loginInfo.plId, loginInfo.userName, loginInfo.token, loginInfo.ssoToken)
        .map((jsonUser) => this.userActions.loginSuccess(jsonUser))
        .retryWhen(this.utilityService.handleRetry)
        .catch(err => Observable.of(this.userActions.loginFail()));
    });

  @Effect() loginSuccess = this.actions$
    .ofType(UserActions.LOGIN_SUCCESS)
    .map(action => this.sessionService.setAuthenticatedPrincipal(action.payload))
    .map(user => {
      this.browserWindow.gtmPush({userId: user.getUserId()});
      this.languageService.setLanguage(user.language);
      return this.userActions.setCurrentUser(user);
    })
    .map(action => {
      this.storeService.getStore().dispatch(this.uiActions.removeGlobalMessage());
      return action;
    });

  @Effect() logout = this.actions$
    .ofType(UserActions.LOGOUT)
    .map(action => this.sessionService.getPrincipal())
    .switchMap(user => this.authService.logout()
      .catch((err) => {
        console.log('Failed to logout from session', err);
        return Observable.of(this.userActions.setCurrentUser(AppPrincipal.createGuest()));
      })
    )
    .map(action => {
      SessionService.logout();
      this.window.location.replace(`${environment.interfacePath.buyerOa}/logout.html`);
      return action;
    });
}

/* istanbul ignore next */




// WEBPACK FOOTER //
// ./src/main/angular/app/main-state/effects/user.effects.ts